const defaultState = {
    appBar: {
        actionItems: [],
        navigationIcon: null,
        progress: {
            isEnabled: false,
            bufferValue: false,
            value: false,
        },
        title: null,
    },
    navigationDrawer: {
        isShown: false,
    },
}

const state = {
    appBar: defaultState.appBar,
    navigationDrawer: defaultState.navigationDrawer,
}

const getters = {}

const mutations = {
    setAppBar(state, appBar) {
        state.appBar = { ...defaultState.appBar, ...appBar }
    },

    setAppBarOptions(state, appBarOptions) {
    // state.appBar = { ...defaultState.appBar, ...appBar }
    },

    setNavigationDrawer(state, navigationDrawer) {
        state.navigationDrawer = { ...defaultState.navigationDrawer, ...navigationDrawer }
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
